import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import LogoutConfirmDialog from '../components/LogoutConfirmDialog';
import { testPanelPing, testPanelSiparisTamAkis } from '../services/testPanelService';
import './TestPanelPage.css';

const TestPanelPage = ({ onLogout }) => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [logoutConfirmOpen, setLogoutConfirmOpen] = useState(false);
  const [log, setLog] = useState('');
  const [busy, setBusy] = useState(false);
  const [teknikKullaniciAdi, setTeknikKullaniciAdi] = useState('ateknik');
  const [adminKullaniciAdi, setAdminKullaniciAdi] = useState('admin');
  const [faturaBilgisi, setFaturaBilgisi] = useState('');

  const appendLog = (title, data) => {
    const line = `\n--- ${title} ---\n${typeof data === 'string' ? data : JSON.stringify(data, null, 2)}\n`;
    setLog((prev) => (prev + line).slice(-120000));
  };

  const handlePing = async () => {
    setBusy(true);
    try {
      const r = await testPanelPing();
      appendLog('ping', r);
    } catch (e) {
      appendLog('ping hata', e.message || String(e));
    } finally {
      setBusy(false);
    }
  };

  const handleSiparisAkis = async () => {
    setBusy(true);
    try {
      const r = await testPanelSiparisTamAkis({
        teknikKullaniciAdi: teknikKullaniciAdi.trim() || 'ateknik',
        adminKullaniciAdi: adminKullaniciAdi.trim() || 'admin',
        ...(faturaBilgisi.trim() ? { faturaBilgisi: faturaBilgisi.trim().substring(0, 500) } : {}),
      });
      appendLog('siparis-tam-akis', r);
    } catch (e) {
      appendLog('siparis-tam-akis hata', e.message || String(e));
    } finally {
      setBusy(false);
    }
  };

  const performLogout = async () => {
    try {
      if (onLogout) await onLogout();
      navigate('/login', { replace: true });
    } catch {
      navigate('/login', { replace: true });
    }
  };

  return (
    <div className="test-panel-root">
      <header className="test-panel-header">
        <div className="test-panel-brand">
          <img src="/assets/img/logo.png" alt="" className="test-panel-logo" />
          <div>
            <h1 className="test-panel-title">SAP</h1>
            <p className="test-panel-sub">Superadmin test paneli — AP / TP akışlarını elle tıklamadan betiklerle çalıştırın</p>
          </div>
        </div>
        <div className="test-panel-header-actions">
          <span className="test-panel-user">{user?.kullaniciAdi || '—'}</span>
          <button type="button" className="test-panel-btn ghost" onClick={() => navigate('/login')}>
            Girişe dön
          </button>
          <button type="button" className="test-panel-btn" onClick={() => setLogoutConfirmOpen(true)}>
            Çıkış
          </button>
        </div>
      </header>

      <LogoutConfirmDialog
        open={logoutConfirmOpen}
        onCancel={() => setLogoutConfirmOpen(false)}
        onConfirm={performLogout}
      />

      <main className="test-panel-main">
        <section className="test-panel-card">
          <h2 className="test-panel-h2">Betik parametreleri</h2>
          <p className="test-panel-hint">
            Sipariş betiği: <strong>ateknik</strong> ile sipariş → <strong>admin</strong> onay ve kargo → <strong>admin</strong> fatura
            (PATCH fatura; boş bırakılırsa sunucu SAP-TEST-FTR-… üretir) → <strong>ateknik</strong> kargo teslim alındı.
          </p>
          <div className="test-panel-fields">
            <label className="test-panel-label">
              Teknik servis kullanıcı adı
              <input
                className="test-panel-input"
                value={teknikKullaniciAdi}
                onChange={(e) => setTeknikKullaniciAdi(e.target.value)}
                disabled={busy}
              />
            </label>
            <label className="test-panel-label">
              Admin tarafı kullanıcı adı
              <input
                className="test-panel-input"
                value={adminKullaniciAdi}
                onChange={(e) => setAdminKullaniciAdi(e.target.value)}
                disabled={busy}
              />
            </label>
            <label className="test-panel-label">
              Fatura bilgisi (opsiyonel)
              <input
                className="test-panel-input"
                value={faturaBilgisi}
                onChange={(e) => setFaturaBilgisi(e.target.value)}
                placeholder="Boş: otomatik SAP-TEST-FTR-…"
                disabled={busy}
              />
            </label>
          </div>
        </section>

        <section className="test-panel-card">
          <h2 className="test-panel-h2">İşlemler</h2>
          <div className="test-panel-actions">
            <button type="button" className="test-panel-btn secondary" onClick={handlePing} disabled={busy}>
              {busy ? 'Çalışıyor…' : 'Bağlantı testi (ping)'}
            </button>
            <button type="button" className="test-panel-btn primary" onClick={handleSiparisAkis} disabled={busy}>
              {busy ? 'Çalışıyor…' : 'Sipariş tam akış (oluştur → onay → kargo → fatura → teslim alındı)'}
            </button>
          </div>
        </section>

        <section className="test-panel-card test-panel-log-card">
          <div className="test-panel-log-header">
            <h2 className="test-panel-h2">Çıktı</h2>
            <button type="button" className="test-panel-btn ghost small" onClick={() => setLog('')} disabled={busy}>
              Temizle
            </button>
          </div>
          <pre className="test-panel-log">{log || 'Henüz çıktı yok.'}</pre>
        </section>
      </main>
    </div>
  );
};

export default TestPanelPage;
